import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment/moment";
import {DebtsModel, SpeedModel} from '../../../../models/debts/debts.model';
import {DebtsService} from "../../../../models/debts/debts.service";


@Component({
    selector: 'speed-calculator-modal',
    templateUrl: 'speed-calculator.template.html',
    styleUrls: []
})

export class SpeedCalculatorComponent implements OnInit, AfterViewInit {

    public debt = new DebtsModel();
    public clientId;

    public dateStart = null;
    public dateFinish = null;
    public factSpeed: number = 0;

    public speedOptions;
    public speedEstimate;

    public speedModel = SpeedModel;

    constructor(
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private debtsService: DebtsService
    ) {



    }

    ngOnInit() {
        this.loadData();
    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {

        this.speedOptions = {
            chartType: 'Gauge',
            dataTable: [
                ['Label', 'Value'],
                ['Speed, %', this.factSpeed],
            ],
            options: {
                redFrom: 0, redTo: 75,
                yellowFrom:75, yellowTo: 110,
                max: this.factSpeed > 130 ? Math.round(this.factSpeed * 1.1) : 130
            },
        }

    }


    // ===========================================================
    // Actions
    // ===========================================================



    public calculate() {
        // this.factSpeed = Math.random() * 150;
        this.debtsService.calculateSpeed(this.clientId, this.debt.id, {start: moment(this.dateStart).format('YYYY-MM-DD'), finish: this.dateFinish})
            .subscribe((res) => {
                this.factSpeed = res.data * 100;

                this.loadData();

                switch (true) {
                    case (this.factSpeed < 75): this.speedEstimate = this.speedModel.SLOW;
                        break;
                    case (this.factSpeed >= 75 && this.factSpeed < 110): this.speedEstimate = this.speedModel.STANDARD;
                        break;
                    case (this.factSpeed >= 110): this.speedEstimate = this.speedModel.FAST;
                        break;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/client-forms/funding-information/speed-calculator/speed-calculator.component.ts